module.exports = __webpack_public_path__ + "static/media/works-with-fitbit.cc7a8b28.png";